import { render, staticRenderFns } from "./vf-drawer-direction-editor.vue?vue&type=template&id=6c2616d8&scoped=true&"
import script from "./vf-drawer-direction-editor.vue?vue&type=script&lang=js&"
export * from "./vf-drawer-direction-editor.vue?vue&type=script&lang=js&"
import style0 from "./vf-drawer-direction-editor.vue?vue&type=style&index=0&id=6c2616d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2616d8",
  null
  
)

export default component.exports